import { CreateSubPerformanceInputDto } from "../../dtos/subPerformance/CreateSubPerformanceInputDto";
import { post } from "../../utills/BaseService";

export async function createSubPerformance(dispatch: any, input: CreateSubPerformanceInputDto): Promise<any> {
    return await post(dispatch, '/subPerformance/createSubPerformance', input);
 };
 